import React from "react";

const LAST_RELOAD_KEY = "neozapp:chunk-reload-at";
const MIN_RELOAD_INTERVAL = 30000;

export const isChunkLoadError = (error) => Boolean(error) && (
  error.name === "ChunkLoadError" || /Loading (CSS )?chunk \S+ failed/i.test(error.message || "")
);

/**
 * After a deploy, a tab opened earlier asks for page files that no longer exist. One reload
 * brings it to the new version; if the file still fails soon after, the error surfaces
 * instead of reloading forever.
 */
export const importWithReload = async (load, { storage = window.sessionStorage, reload = () => window.location.reload(), now = Date.now } = {}) => {
  try {
    return await load();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
    try {
      if (now() - Number(storage.getItem(LAST_RELOAD_KEY) || 0) < MIN_RELOAD_INTERVAL) throw error;
      storage.setItem(LAST_RELOAD_KEY, String(now()));
    } catch (_) {
      throw error;
    }
    reload();
    return new Promise(() => {});
  }
};

export const lazyWithReload = (load) => React.lazy(() => importWithReload(load));
